import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { CiLock, CiUnlock } from 'react-icons/ci';

const RoulettePublic = () => {
    const { i18n } = useTranslation()
    const params = useParams();

    const [eventDetails, setEventDetails] = useState([]);
    const [rouletteDetails, setRouletteDetails] = useState([]);
    const [battleDetails, setBattleDetails] = useState([]);

    const [firstSelection, setFirstSelection] = useState(null);
    const [secondSelection, setSecondSelection] = useState(null);
    const [isSpinningLeft, setIsSpinningLeft] = useState(false); // Left spinner control
    const [isSpinningRight, setIsSpinningRight] = useState(false); // Right spinner control
    const [isLocked, setIsLocked] = useState(false);

    // Function to start both spinners
    const startBothSpinners = () => {
        if (!isLocked && !isSpinningLeft && !isSpinningRight) {
            setIsSpinningLeft(true);
            setIsSpinningRight(true);
        }
    };

    // Function to stop the left spinner
    const stopLeftSpinner = () => {
        if (isSpinningLeft) {
            finalizeSelection('left');
            setIsSpinningLeft(false);
        }
    };

    // Function to stop the right spinner
    const stopRightSpinner = () => {
        if (isSpinningRight) {
            finalizeSelection('right');
            setIsSpinningRight(false);
        }
    };

    // Continuously spin while isSpinningLeft is true
    useEffect(() => {
        if (isSpinningLeft) {
            const spin = setInterval(() => {
                const firstIndex = Math.floor(Math.random() * rouletteDetails?.keywords?.length);
                setFirstSelection(rouletteDetails?.keywords[firstIndex]);
            }, 100); // Update every 100ms for continuous spinning

            return () => clearInterval(spin);
        }
    }, [isSpinningLeft, rouletteDetails]);

    // Continuously spin while isSpinningRight is true
    useEffect(() => {
        if (isSpinningRight) {
            const spin = setInterval(() => {
                const secondIndex = Math.floor(Math.random() * rouletteDetails.keywords.length);
                setSecondSelection(rouletteDetails.keywords[secondIndex]);
            }, 100); // Update every 100ms for continuous spinning

            return () => clearInterval(spin);
        }
    }, [isSpinningRight, rouletteDetails]);

    // Finalize the selection when stopping
    const finalizeSelection = (spinner) => {
        if (spinner === 'left') {
            const firstIndex = Math.floor(Math.random() * rouletteDetails.keywords.length);
            setFirstSelection(rouletteDetails?.keywords[firstIndex]);
        } else if (spinner === 'right') {
            const secondIndex = Math.floor(Math.random() * rouletteDetails.keywords.length);
            setSecondSelection(rouletteDetails?.keywords[secondIndex]);
        }
    };

    const getEventSingleBattleRoulette = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/EventSingleBattleRouletteGet/${params.eventId}/${params.battelId}`);
            const data = await response.data;

            if (data.status === 0) {
                toast.error(data.message);
            }

            if (data.status === 1) {
                setEventDetails(data.event);
                setRouletteDetails(data.Roulette);
                setBattleDetails(data.updatedBattle);
            }

        } catch (error) {
            console.log('Error:', error);
            toast.error(error);
        }
    };
    

    const submitBattleKeyword = async () => {
        const apiData = {
            eventId: params.eventId,
            battleId: params.battelId,
            battle_status: 'live',
            battle1_keyword_eng: firstSelection.keyword_eng1,
            battle1_keyword_jap: firstSelection.keyword_jap1,
            battle2_keyword_eng: secondSelection.keyword_eng2,
            battle2_keyword_jap: secondSelection.keyword_jap2
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/EventSingleBattleKeyUpdate`, apiData);
            const data = await response.data;

            if (data.status === 0) {
                toast.error(data.message);
            }

            if (data.status === 1) {
                // toast.success(data.message);
                getEventSingleBattleRoulette();
            }

        } catch (error) {
            console.log('Error:', error);
            toast.error(error);
        }
    };

    const lockBattle = () => {
        setIsLocked(!isLocked); // Set roulette to locked
        setIsSpinningLeft(false); // Stop left spinner
        setIsSpinningRight(false); // Stop right spinner
    };

    useEffect(() => {
        getEventSingleBattleRoulette();
    }, []);
    

    useEffect(() => {
        if (!isSpinningLeft && !isSpinningRight && firstSelection && secondSelection) {
            submitBattleKeyword();
        }
    }, [isSpinningLeft, isSpinningRight, firstSelection, secondSelection]);
    
    return (
        <>
            <div className='main-content py-0'>
                <div className='padding2'>
                    <div className='container'>
                        {/* <h4 className='fw-bold text-center'>Limits</h4> */}
                        {
                            eventDetails?.event_type === "battle_club" ? <img src={require('../assets/images/battle_club_logo.PNG')} className='img-fluid logo1 mx-auto d-block' alt="" style={{"height": "55px"}} />
                            : <img src={require('../assets/images/logo.png')} className='img-fluid logo1 mx-auto d-block' alt="" style={{"height": "55px"}} />
                        }
                        
                        <div className='card card1 mt-3 bg-transparent border-0'>
                            <div className='card-body p-0'>
                                <div className='d-flex justify-content-around' >
                                    {/* Left Spinner */}
                                    <div className='w-50'>
                                        <div className='spin-maindiv' 
                                        onClick={isSpinningLeft ? stopLeftSpinner : startBothSpinners}
                                        style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}>
                                            <div className={`spin-div ${isSpinningLeft ? 'spin-active' : 'overflow-hidden'}`}>
                                                {!isSpinningLeft && (battleDetails?.battle1_keyword_eng || battleDetails?.battle2_keyword_eng || firstSelection !== null) ? (
                                                    <div className='text-center'>
                                                        <h4 className='mb-0 display-5 fw-semibold'>
                                                            {firstSelection !== null 
                                                                ? <span>{firstSelection.keyword_eng1} <br /> {firstSelection.keyword_jap1}</span>
                                                                : <span>{battleDetails?.battle1_keyword_eng} <br /> {battleDetails?.battle1_keyword_jap}</span>
                                                            }
                                                        </h4>
                                                    </div>
                                                ) : <div className='roulette-div'>
                                                    {rouletteDetails.keywords && [...rouletteDetails.keywords, ...rouletteDetails.keywords].map((item, index) => (
                                                        <div key={index} className={`spin-item display-5 fw-semibold ${item === firstSelection && !isSpinningLeft ? 'highlight' : ''}`}>
                                                            {item.keyword_eng1} <br />
                                                            {item.keyword_jap1}
                                                        </div>
                                                    ))}
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='border-spin'></div>
                                    {/* Right Spinner */}
                                    <div className='w-50'>
                                        <div className='spin-maindiv' 
                                        onClick={isSpinningRight ? stopRightSpinner : startBothSpinners}
                                        style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}>
                                            <div className={`spin-div ${isSpinningRight ? 'spin-active' : 'overflow-hidden'}`}>
                                                {!isSpinningRight && (battleDetails?.battle1_keyword_eng || battleDetails?.battle2_keyword_eng || secondSelection !== null) ? (
                                                    <div className='text-center'>
                                                        <h4 className='mb-0 display-5 fw-semibold'>
                                                            {secondSelection !== null 
                                                                ? <span>{secondSelection.keyword_eng2} <br /> {secondSelection.keyword_jap2}</span>
                                                                : <span>{battleDetails?.battle2_keyword_eng} <br /> {battleDetails?.battle2_keyword_jap}</span>
                                                            }
                                                        </h4>
                                                    </div>
                                                ) : <div className='roulette-div'>
                                                    {rouletteDetails.keywords && [...rouletteDetails.keywords, ...rouletteDetails.keywords].map((item, index) => (
                                                        <div key={index} className={`spin-item display-5 fw-semibold ${item === secondSelection && !isSpinningRight ? 'highlight' : ''}`}>
                                                            {item.keyword_eng2} <br />
                                                            {item.keyword_jap2}
                                                        </div>
                                                    ))}
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* {!isSpinningLeft && !isSpinningRight && (battleDetails?.battle1_keyword_eng || battleDetails?.battle2_keyword_eng) && (
                                <div className='mt-4 text-center'>
                                    <h4 className='text-white'>
                                        <span className='mx-1 d-inline-block me-3'>{battleDetails?.battle1_keyword_eng} <br /> {battleDetails?.battle1_keyword_jap}</span>
                                        <span className='mx-1 d-inline-block'>{battleDetails?.battle2_keyword_eng} <br /> {battleDetails?.battle2_keyword_jap}</span>
                                    </h4>
                                </div>
                            )} */}
                        </div>
                    </div>

                    <div className='container-fluid mt-4'>  
                        <div className='row align-items-center'>
                            <div className='col-3'>
                                {
                                    rouletteDetails?.sponsor_img && <img src={`${process.env.REACT_APP_IMAGES_URL}/${rouletteDetails.sponsor_img}`} crossOrigin="anonymous" className='img-fluid object-fit-contain' alt="" style={{width: "80px",maxHeight: "30px"}} />
                                }
                            </div>
                            <div className='col-6 text-center'>
                                <h2 className='text-white fw-normal'>
                                    <span className='mx-1 d-inline-block me-3'>{i18n.language === 'en' ? eventDetails.title_eng : eventDetails.title_jap}</span>
                                </h2>
                            </div>
                            <div className='col-3'>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="lock-icon text-end">
                    {
                        eventDetails?.event_type === "battle_club" ? <Link to={`/live-event-battle/${params.eventId}`} className='btn btn1 py-2' style={{minWidth: "auto"}}>Go to Battle</Link>
                        : <Link to={`/live-event/${params.eventId}`} className='btn btn1 py-2' style={{minWidth: "auto"}}>Go to Battle</Link>
                    }
                    <br/>
                    {
                        !isLocked ? <Link onClick={lockBattle}><CiUnlock /></Link>
                        : <Link onClick={lockBattle}><CiLock /></Link>
                    }
                </div>
                
            </div>

        </>
    );
};

export default RoulettePublic;
